import { Today } from "@clockwise/design-system/icons";
import {
  PageLayout,
  PageLayoutContent,
} from "@clockwise/web-commons/src/ui/page-layout/PageLayout";
import { SecurityRounded } from "@material-ui/icons";
import React, { useEffect } from "react";
import Helmet from "react-helmet";
import FlexibleMeetings from "../components/flexible-meetings/FlexibleMeetings";
import { MonetizationBadge } from "../components/flexible-meetings/MonetizationBadge";
import { PageEvents, page } from "../util/analytics.util";

import { Tabs } from "@clockwise/design-system";
import { useLocation } from "react-router-dom";
import { FlexibleHoldsSection } from "../components/flexible-meetings/FlexibleHoldsSection";
import { FlexibleHoldsSectionSamHack } from "../components/flexible-meetings/FlexibleHoldsSectionSamHack";
import { FlexibleMeetingsSamHack } from "../components/flexible-meetings/FlexibleMeetingsSamHack";
import { useFeatureFlag } from "../launch-darkly";

const FlexibleMeetingsPage = () => {
  const [onNewFlexPage] = useFeatureFlag("hacksprint-sam-flex-page");
  useEffect(() => {
    page(PageEvents.FLEXIBLE_MEETINGS_PAGE);
  }, []);

  const { hash } = useLocation();

  const tabData = [
    {
      title: (
        <div className="cw-flex cw-flex-row cw-items-center cw-justify-center cw-w-full cw-space-x-1.5">
          <Today className="cw-text-16" />
          <div className="cw-max-w-full cw-relative">Meetings</div>
        </div>
      ),
      content: <FlexibleMeetings />,
      key: "meetings",
    },
    {
      title: (
        <div className="cw-flex cw-flex-row cw-items-center cw-justify-center cw-w-full cw-space-x-2">
          <SecurityRounded className="cw-text-16" />
          <div className="cw-max-w-full cw-relative">Holds</div>
        </div>
      ),
      content: <FlexibleHoldsSection />,
      key: "holds",
    },
  ];

  const newFlexPageTabs = [
    {
      title: (
        <div className="cw-flex cw-flex-row cw-items-center cw-justify-center cw-w-full cw-space-x-1.5">
          <Today className="cw-text-16" />
          <div className="cw-max-w-full cw-relative">Meetings</div>
        </div>
      ),
      content: <FlexibleMeetingsSamHack />,
      key: "meetings",
    },
    {
      title: (
        <div className="cw-flex cw-flex-row cw-items-center cw-justify-center cw-w-full cw-space-x-2">
          <SecurityRounded className="cw-text-16" />
          <div className="cw-max-w-full cw-relative">Holds</div>
        </div>
      ),
      content: <FlexibleHoldsSectionSamHack />,
      key: "holds",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Flexibility · Clockwise</title>
      </Helmet>
      <PageLayout
        title={
          <div className="cw-flex cw-items-center">
            Flexibility
            <MonetizationBadge />
          </div>
        }
      >
        <PageLayoutContent>
          <div>
            {onNewFlexPage ? (
              <Tabs tabs={newFlexPageTabs} defaultTabIndex={hash === "#holds" ? 1 : 0} />
            ) : (
              <Tabs tabs={tabData} defaultTabIndex={hash === "#holds" ? 1 : 0} />
            )}
          </div>
        </PageLayoutContent>
      </PageLayout>
    </>
  );
};

export default FlexibleMeetingsPage;
